import React, { FC } from "react";
import { Box, makeStyles, withStyles } from "@material-ui/core";
import { useTranslation } from "Providers/TranslationProvider";
import { Alert, AlertTitle, Color } from "@material-ui/lab";
import { color, px } from "Configs/theme";

interface Props {
  error: Error;
  severity?: Color;
  padding?: px;
  color?: Color
}

const ErrorView: FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
      <Box className={classes.root} padding={props.padding ?? px.m}>
        <StyledAlert severity={props.severity || "error"} color={props.color}>
          {!props.severity && <AlertTitle>{t("ErrorView_Title")}</AlertTitle>}
          {props.error.message}
        </StyledAlert>
      </Box>
  );
};

export default ErrorView;

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
});

const StyledAlert = withStyles({
  standardWarning: {
    backgroundColor: color.primaryBackground02,
    '& .MuiAlert-icon': {
      color: color.primaryBackground
    },
    '& .MuiAlert-message': {
      color: color.primaryColor
    },
  },
})(Alert);
